import { of, take, mapTo, switchMap, catchError, throwError } from 'rxjs';

import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { AuthStore } from '@/app/core/store/auth';
import { ProfileService } from '@/app/api/profile';
import { SessionService } from '@/app/core/services/session';

export const profileResolverGuard: CanMatchFn = (route, segments) => {
  const authStore = inject(AuthStore);
  const profileService = inject(ProfileService);
  const sessionsService = inject(SessionService);

  return authStore.authUser$.pipe(
    take(1),
    switchMap((currentUser) => (currentUser ? of(currentUser) : profileService.getProfile())),
    catchError((error) => {
      sessionsService.navigateToLogin();
      return throwError(() => error);
    }),
    mapTo(true),
  );
};
